import { createRouter, createWebHashHistory } from "vue-router";

import DefaultLayout from "@/layouts/DefaultLayout.vue";
import HomeView from "@/views/HomeView.vue";
import AboutView from "@/views/AboutView.vue";
import LoginView from "@/views/LoginView.vue";
import ProfileView from "@/views/ProfileView.vue";
import FacilitiesView from "@/views/FacilitiesView.vue";

import AssessmentInfrastructure from "@/views/assessment/AssessmentInfrastructure.vue";
import AssessmentUtilities from "@/views/assessment/AssessmentUtilities.vue";
import AssessmentSpaces from "@/views/assessment/AssessmentSpaces.vue";
import AssessmentDisasters from "@/views/assessment/AssessmentDisasters.vue";
import AssessmentGender from "@/views/assessment/AssessmentGender.vue";
import AssessmentCost from "@/views/assessment/AssessmentCost.vue";

import AssessmentAvailability from "@/views/services/AssessmentAvailability.vue";
import AssessmentBeforeAfter from "@/views/services/AssessmentBeforeAfter.vue";
import AssessmentMotherChild from "@/views/services/AssessmentMotherChild.vue";
import AssessmentBarriers from "@/views/services/AssessmentBarriers.vue";
import AssessmentReferral from "@/views/services/AssessmentReferral.vue";
import AssessmentIpc from "@/views/services/AssessmentIpc.vue";
import AssessmentRisk from "@/views/services/AssessmentRisk.vue";

import AssessmentStaffSummary from "@/views/staff/AssessmentStaffSummary.vue";
import AssessmentStaffDistribution from "@/views/staff/AssessmentStaffDistribution.vue";
import AssessmentStaffCoverage from "@/views/staff/AssessmentStaffCoverage.vue";
import AssessmentStaffTraining from "@/views/staff/AssessmentStaffTraining.vue";
import AssessmentStaffHrm from "@/views/staff/AssessmentStaffHrm.vue";

import AssessmentFinanceStatus from "@/views/finance/AssessmentFinanceStatus.vue";
import AssessmentFinanceFees from "@/views/finance/AssessmentFinanceFees.vue";
import AssessmentFinanceDisruption from "@/views/finance/AssessmentFinanceDisruption.vue";
import AssessmentFinanceBarriers from "@/views/finance/AssessmentFinanceBarriers.vue";
import AssessmentFinanceReporting from "@/views/finance/AssessmentFinanceReporting.vue";

import AssessmentGovernanceStructure from "@/views/governance/AssessmentGovernanceStructure.vue";
import AssessmentGovernancePolicies from "@/views/governance/AssessmentGovernancePolicies.vue";
import AssessmentGovernancePlanning from "@/views/governance/AssessmentGovernancePlanning.vue";
import AssessmentGovernanceCoordination from "@/views/governance/AssessmentGovernanceCoordination.vue";
import AssessmentGovernanceCommunity from "@/views/governance/AssessmentGovernanceCommunity.vue";
import AssessmentGovernanceRecovery from "@/views/governance/AssessmentGovernanceRecovery.vue";

import ReportsView from "@/views/ReportsView.vue";
import SettingsView from "@/views/SettingsView.vue";
import NationalView from "@/views/NationalView.vue";
import MapView from "@/views/MapView.vue";
import PrioritiesView from "@/views/PrioritiesView.vue";
import AssessmentView from "@/views/AssessmentView.vue";
import EquityView from "@/views/EquityView.vue";
import RagDashboardView from "@/views/RagDashboardView.vue";
import ScenariosView from "@/views/ScenariosView.vue";
import InvestmentCostsView from "@/views/InvestmentCostsView.vue";
import FacilityDetailsView from "@/views/FacilityDetailsView.vue";
import ExportView from "@/views/ExportView.vue";
import DatabasetView from "@/views/DatabasetView.vue";
import MethodologyView from "@/views/MethodologyView.vue";
import UsersView from "@/views/UsersView.vue";
import ForgotPasswordView from "@/views/ForgotPasswordView.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      guestOnly: true,
    },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPasswordView,
    meta: { guestOnly: true },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPasswordView,
    meta: { guestOnly: true },
  },
  {
    path: "/",
    redirect: "/login",
  },

  {
    path: "/",
    component: DefaultLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "home",
        name: "home",
        component: HomeView,
      },
      {
        path: "national",
        name: "national",
        component: NationalView,
      },
      {
        path: "map",
        name: "map",
        component: MapView,
      },
      {
        path: "priorities",
        name: "priorities",
        component: PrioritiesView,
      },
      {
        path: "assessment",
        name: "assessment",
        component: AssessmentView,
      },
      {
        path: "about",
        name: "about",
        component: AboutView,
      },
      {
        path: "profile",
        name: "profile",
        component: ProfileView,
      },
      {
        path: "facilities",
        name: "facilities",
        component: FacilitiesView,
      },

      {
        path: "assessment/infrastructure/structural",
        name: "assessment_structural",
        component: AssessmentInfrastructure,
      },
      {
        path: "assessment/infrastructure/spaces",
        name: "assessment_spaces",
        component: AssessmentSpaces,
      },
      {
        path: "assessment/infrastructure/utilities",
        name: "assessment_utilities",
        component: AssessmentUtilities,
      },
      {
        path: "assessment/infrastructure/disasters",
        name: "assessment_disasters",
        component: AssessmentDisasters,
      },
      {
        path: "assessment/infrastructure/gender",
        name: "assessment_gender",
        component: AssessmentGender,
      },
      {
        path: "assessment/infrastructure/cost",
        name: "assessment_cost",
        component: AssessmentCost,
      },

      {
        path: "assessment/services/availability",
        name: "assessment_availability",
        component: AssessmentAvailability,
      },
      {
        path: "assessment/services/before-after",
        name: "assessment_before_after",
        component: AssessmentBeforeAfter,
      },
      {
        path: "assessment/services/mother-child",
        name: "assessment_mother_child",
        component: AssessmentMotherChild,
      },
      {
        path: "assessment/services/barriers",
        name: "assessment_barriers",
        component: AssessmentBarriers,
      },
      {
        path: "assessment/services/referral",
        name: "assessment_referral",
        component: AssessmentReferral,
      },
      {
        path: "assessment/services/ipc",
        name: "assessment_ipc",
        component: AssessmentIpc,
      },
      {
        path: "assessment/services/risk",
        name: "assessment_risk",
        component: AssessmentRisk,
      },

      {
        path: "assessment/staff/summary",
        name: "assessment_staff_summary",
        component: AssessmentStaffSummary,
      },
      {
        path: "assessment/staff/distribution",
        name: "assessment_staff_distribution",
        component: AssessmentStaffDistribution,
      },
      {
        path: "assessment/staff/coverage",
        name: "assessment_staff_coverage",
        component: AssessmentStaffCoverage,
      },
      {
        path: "assessment/staff/training",
        name: "assessment_staff_training",
        component: AssessmentStaffTraining,
      },
      {
        path: "assessment/staff/hrm",
        name: "assessment_staff_hrm",
        component: AssessmentStaffHrm,
      },

      {
        path: "assessment/finance/status",
        name: "assessment_finance_status",
        component: AssessmentFinanceStatus,
      },
      {
        path: "assessment/finance/fees",
        name: "assessment_finance_fees",
        component: AssessmentFinanceFees,
      },
      {
        path: "assessment/finance/disruption",
        name: "assessment_finance_disruption",
        component: AssessmentFinanceDisruption,
      },
      {
        path: "assessment/finance/barriers",
        name: "assessment_finance_barriers",
        component: AssessmentFinanceBarriers,
      },
      {
        path: "assessment/finance/reporting",
        name: "assessment_finance_reporting",
        component: AssessmentFinanceReporting,
      },

      {
        path: "assessment/governance/structure",
        name: "assessment_governance_structure",
        component: AssessmentGovernanceStructure,
      },
      {
        path: "assessment/governance/policies",
        name: "assessment_governance_policies",
        component: AssessmentGovernancePolicies,
      },
      {
        path: "assessment/governance/planning",
        name: "assessment_governance_planning",
        component: AssessmentGovernancePlanning,
      },
      {
        path: "assessment/governance/coordination",
        name: "assessment_governance_coordination",
        component: AssessmentGovernanceCoordination,
      },
      {
        path: "assessment/governance/community",
        name: "assessment_governance_community",
        component: AssessmentGovernanceCommunity,
      },
      {
        path: "assessment/governance/recovery",
        name: "assessment_governance_recovery",
        component: AssessmentGovernanceRecovery,
      },

      {
        path: "reports",
        name: "reports",
        component: ReportsView,
      },
      {
        path: "settings",
        name: "settings",
        component: SettingsView,
      },
      {
        path: "equity",
        name: "equity",
        component: EquityView,
      },
      {
        path: "rag",
        name: "rag",
        component: RagDashboardView,
      },
      {
        path: "scenarios",
        name: "scenarios",
        component: ScenariosView,
      },
      {
        path: "investment",
        name: "investment",
        component: InvestmentCostsView,
      },
      {
        path: "facilities/:id",
        name: "facility-details",
        component: FacilityDetailsView,
      },
      {
        path: "export",
        name: "export",
        component: ExportView,
      },
      {
        path: "database",
        name: "database",
        component: DatabasetView,
      },
      {
        path: "methodology",
        name: "methodology",
        component: MethodologyView,
      },
      {
        path: "users",
        name: "users",
        component: UsersView,
      },
    ],
  },

  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const storedUser = localStorage.getItem("user");

  let user = null;

  try {
    user = storedUser ? JSON.parse(storedUser) : null;
  } catch {
    user = null;
  }

  const isAuthenticated = Boolean(
    token && user && typeof user === "object" && user.id
  );

  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);

  const guestOnly = to.matched.some((route) => route.meta.guestOnly);

  if (requiresAuth && !isAuthenticated) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    localStorage.removeItem("permissions");
    localStorage.removeItem("isAuthenticated");

    return next({
      name: "login",
      query: {
        redirect: to.fullPath,
      },
    });
  }

  if (guestOnly && isAuthenticated) {
    return next({ name: "home" });
  }

  return next();
});

export default router;
